import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  input,
  output,
  signal,
  viewChild,
  WritableSignal,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';
import { IMaskDirective } from 'angular-imask';
import { of } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { FormErrorComponent } from '../error/form-error.component';
import { IsErrorColoredPipe } from '../error/form-error.pipe';

@Component({
  selector: 'shared-form-input-text',
  templateUrl: './form-input-text.component.html',
  styleUrls: ['./form-input-text.component.css'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    IMaskDirective,
    IsErrorColoredPipe,
    FormErrorComponent,
  ],
})
export class FormInputTextComponent implements AfterViewInit {
  readonly inputElement = viewChild<ElementRef>('inputElement');

  type = input<'text' | 'password'>('text');

  title = input<string | undefined>();

  mask = input<string | undefined>();

  tabIndex = input<number | undefined>();

  control = input.required<FormControl<unknown>>();

  validationErrors = input<ValidationErrors>();

  focus = input(false);

  withValidationDelay = input(false);

  testId = input<string | undefined>(undefined);

  readonly focused = output<void>();

  passwordInputType: 'text' | 'password' = 'password';

  invalidControl: WritableSignal<boolean> = signal(false);

  constructor() {
    effect(() => {
      this.control()
        .valueChanges.pipe(
          switchMap(() => of(this.control().dirty && this.control().invalid)),
          debounceTime(this.withValidationDelay() ? 700 : 0),
        )
        .subscribe((value) => {
          this.invalidControl.set(value);
        });
    });
  }

  ngAfterViewInit(): void {
    if (!this.focus()) {
      return;
    }

    this.inputElement()?.nativeElement.focus();
  }

  onFocus(): void {
    this.focused.emit();
  }

  onPasswordToggleClick(): void {
    this.passwordInputType =
      this.passwordInputType === 'password' ? 'text' : 'password';
  }
}
